import React, { Component } from 'react'
import ravi from '../../images/ravi.png'
import Carousel from 'react-bootstrap/Carousel';
import { pink } from '../../constants';

class Teams_slider extends Component {
    testimonials = [
        {
            name:"Harpreet Singh",
            post:"Technical Head",
            description:'Basically I am not taking it as an internship experience or earning opportunity, I only want to work with a dedicated team like this. The agenda of Team Empower Bharat is not only to build a startup but also to lift up the education level of rural India so that they can also achieve their goals.Moreover, Working with such a great leader is an achievement in itself, and I am very thankful as he appointed me as a developer in Empower Bharat.',
            src:"https://drive.google.com/uc?export=view&id=1y2CICG-kUuerIp2wO6GxMbDFepFNQjRo"
        },
        {
            name: "Sushmitha Prakash",
            post: "Graphics Designer",
            description: "I am very happy to be part of this reputed organization and the concept behind this work is amazing. I must say about the team leaders, who are very down to earth, and it is very flexible to work together. I am learning new things daily with this team.The concept of this organization is very thoughtful and I wish this organization to be very successful in the coming day.",
            src: "https://drive.google.com/uc?export=view&id=1nxP4yT43DYSTqu1Z-W9S54PHQibjh_kq"
        },
        {
            name: "Komal",
            post: "UI and UX Designer",
            description: "Thank you so much for giving me the opportunity to intern with Empower Bharat. I have learned so much and had the chance to work with some amazing people. And on great projects. I appreciate team mentorship and the healthy environment that the team leader provided. Thank you for your guidance, support, and advice. I will never forget this experience and I will always be grateful for the opportunity you gave me.",
            src: "https://drive.google.com/uc?export=view&id=1GFGwj9njOIhSiTsPAX8H3j3PJAOm21Ji"

        },
        {
            name: "Shweta",
            post: "Script Writer & Animator",
            description: "This is not just a company, it's an emotion for me.  The team leader has always supported his employees and gives them the freedom to do work in their way so that we can do something new and creative. After joining EB, I learned a lot of new things, which no doubt will open the doors for better opportunities in my career in the future.",
            src: "https://drive.google.com/uc?export=view&id=1D1xJP06ZRM0J2ADrNrzdKfxaDQPjvHJr"
        },
        {
            name: "Shraddha Kakadiya",
            post: "Content Developer",
            description: "Within the first few days of working with Empower Bharat, I knew I was in the right place. The team is extremely supportive and collaborative. We are always encouraged to be creative and try our hand at any aspect of the project we see fit, thus constantly challenging and enhancing our skills. The work flexibility really allows our minds to rest and flow with ideas.",
            src: "https://drive.google.com/uc?export=view&id=1eFk75sP52mbuovxaOc9Wxd5KnM_drO4m"
        },

        {
            name: "Saurabh mandal",
            post: "Designer & Animator",
            description: "I feel more empowered in my field as this internship has shown me what exactly it is I enjoy about my chosen field. The internship has undoubtedly provided me with invaluable experience that will serve me well in the future, and I have met some extraordinarily enthusiastic and inspiring individuals. I was nervous because it was my first time working on a remote.",
            src: "https://drive.google.com/uc?export=view&id=1mS0k9VN57AZBMsHuQ2HXt1vvYwBrdk-h"
        },

        {
            name: "Atul Pandey",
            post: "Script Writer",
            description: "मेरा हमेशा से यह मानना रहा है कि गांवों की बेहतरी के बिना हमारे देश की बेहतरी नहीं हो सकती है। गांव कोई अतीत नहीं हैं बल्कि भविष्य हैं। पर्यावरण प्रदूषण और ग्लोबल वार्मिंग जैसी चीजों से लड़ने में गांव महत्वपूर्ण भूमिका निभा सकते हैं।मुझे इंपावर भारत का विचार काफी अच्छा लगा। मुझे इसके साथ काम करके बेहद खुशी हुई। मुझे इस बात से बेहद खुशी हुई की आज भी ऐसी सस्थाएं हैं जो गांव केंद्रित काम करना चाहती हैं। मैं एंपावर भारत के बेहतर भविष्य की कामना करता हूं।",
            src: "https://drive.google.com/uc?export=view&id=14OJsLmyj24Ln6cSPHEnPFjL099Tdtd9z"
        },

        {
            name: "Archita",
            post: "Content Developer",
            description: "I feel blessed to be a part of Empower Bharat I have learned many new things here they taught me the value of rural areas and how we are forgetting the backend of our economy, they supported me each and every phase of life I am lucky to work as n intern in Empower Bharat",
            src: "https://drive.google.com/uc?export=view&id=1n9063WQTmD7zI4kJmOLTVoeSLpFMWjW8"
        },
        {
            name: "Aisha Khaled",
            post: "Graphics Designer",
            description: "I'm really glad and delighted to work with Empower Bharat team such a friendly and supportive team. In Empower Bharat the cooperative and enjoyable environment made me realize that the project environment is really important as it helped me produce the best work and I would of course love to work with them again.",
            src: "https://drive.google.com/uc?export=view&id=1yeC8IcLP-KZPqkxqyin6d_7x9uyPZ_65"
        },
        

    ]
    render() {
        return (

            <div style={{ width: "100%" }}>
                <Carousel variant="dark">
                    {this.testimonials.map((val, index) => {
                        return <Carousel.Item interval={3000} key={index} style={{ backgroundColor: "white", width: "100%" }}>

                            <div style={{ height: "470px", width: "350px", display: "flex", flexDirection: "column", marginLeft: "auto", marginRight: "auto", alignItems: "center", backgroundColor: "white" }}>
                                <div style={{ position: "absolute", width: "120px", height: "120px" }}>
                                    <img
                                        height="130px"
                                        width="130px"
                                        src={val.src} alt="image"
                                        alt="First slide"
                                        style={{ objectFit: "cover", borderRadius: "100px", border: "7px solid ", borderColor: pink, }}
                                    />

                                </div>

                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", backgroundColor: pink, padding: "50px 10px 50px 10px", marginTop: "90px", height: "400px" }}>
                                    <span style={{ fontSize: "20px", fontWeight: "500", color: "white" }}>{val.name}</span>
                                    <span style={{ fontSize: "18px", color: "white" }}>{val.post}</span>
                                    <span style={{ textAlign: "center", fontSize: "15px", marginTop: "15px", color: "white" }}>{val.description}</span>

                                </div>
                            </div>


                        </Carousel.Item>
                    })}


                </Carousel>
            </div>


        )
    }
}

export default Teams_slider
